import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { toFullName } from '@repo/toolkit/to-full-name'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'
import { t } from 'i18next'

import { friendPlaceEnumMapping } from '../../../../lib/types/enums/friend/friend-place.enum'
import { Friend } from '../../../../lib/types/models/friend/friend'
import InformationToolTip from '../../../elements/information-tooltip'

type Props = { friends?: Friend[] }

const OlCenterEnrollmentTableFriendsTooltip = ({ friends }: Props) => {
  return (
    <div>
      {friends && friends.length > 0 ? (
        <div className="flex flex-wrap gap-1 my-3">
          {friends.map((friend) => {
            const IconComponent = friendPlaceEnumMapping[friend.type]?.icon

            return (
              <InformationToolTip
                key={friend.id}
                contentVariant="secondary"
                align="end"
                icon={
                  <Badge
                    key={friend.id}
                    variant="blue"
                    size="small"
                    icon={IconComponent && <IconComponent color={tailwindColors.blue.DEFAULT} />}
                    text={toFullName(friend.firstName, friend.lastName, {
                      options: { mode: 'lastname-firstname' }
                    })}
                  />
                }
                size="small"
              >
                <Typography variant={'label-medium'} color={tailwindColors.black.DEFAULT}>
                  {t(friendPlaceEnumMapping[friend.type].label)}
                </Typography>
              </InformationToolTip>
            )
          })}
        </div>
      ) : (
        '-'
      )}
    </div>
  )
}

export default OlCenterEnrollmentTableFriendsTooltip
